import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';

// Components
import { DataTableComponent } from './components/data-table/data-table.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { TopbarUserMenuComponent } from './components/topbar-user-menu/topbar-user-menu.component';
import { TopbarNotificationsComponent } from './components/topbar-notifications/topbar-notifications.component';
import { AlertSnackbarComponent } from './components/alert-snackbar/alert-snackbar.component';
import { AlertToastStackComponent } from './components/alert-toast-stack/alert-toast-stack.component';
import { MarinaSelectionDialogComponent } from './components/marina-selection-dialog/marina-selection-dialog.component';

const COMPONENTS = [
  AlertSnackbarComponent,
  AlertToastStackComponent,
  DataTableComponent,
  FileUploadComponent,
  DatePickerComponent,
  StatusBadgeComponent,
  ConfirmationDialogComponent,
  LoadingSpinnerComponent,
  TopbarUserMenuComponent,
  TopbarNotificationsComponent,
  MarinaSelectionDialogComponent,
];

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: COMPONENTS,
  exports: [MaterialModule, ...COMPONENTS],
})
export class UiModule { }

